<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xZgKme/tc-custom/9781504062633.jpg?1737160398429" alt="This image is the cover for the book Most Dangerous Game"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Most Dangerous Game
      </h1>
      <p class="bookDescription body article font2">
        <b>From one of America’s most popular short story writers and an Academy Award nominee: the O. Henry Award–winning tale that inspired the movie <i>The Hunt</i>.</b><br/>  <br/> A subject of mysterious rumors and superstition, the deserted Caribbean Island was shrouded in an air of peril. To Sanger Rainsford, who fell off a yacht and washed up on its shores, the abandoned isle was a welcome paradise. But unknown to the big-game hunter, a predator lurked in its lush jungles—one more dangerous than any he had ever encountered: a human.<br/>  <br/> First published in 1924, this suspenseful tale “has inspired serial killers, films and stirred controversy in schools. A century on, the story continues to thrill” (<i>The Telegraph</i>).<br/>  <br/> “[A] tense, relentless story of man-against-man adventure, in which the hunter Sanger Rainsford learns, at the hands of General Zaroff, what it means to be hunted.” —<i>Criterion</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Connell
      </h2>
      
      <p class="authorDescription body article">Richard Connell (1893&ndash;1949) was an American author and journalist best remembered for his short story &ldquo;The Most Dangerous Game&rdquo; (1924). Connell was one of the most popular American short story writers of his time, and his stories were published in the<I>&#160;Saturday Evening Post</I>&#160;and&#160;<I>Collier&rsquo;s</I>&#160;magazines. He had equal success as a journalist and screenwriter, and his screenplay for the movie&#160;<I>Meet John Doe</I>&#160;was nominated for an Academy Award in 1942.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6e5a674c